// import React from 'react'
// import Header from './Header'
// import Footer from './Footer'
// import '../Css/Contact.css';
// import { Link } from 'react-router-dom';
// import banner from '../banner/new.jpeg';
// function Contact() {
//   return (
//     <div>
//     <Header/>
 
//    {/* Page Intro Section */}
//    <section
//         className="row page_intro"
//         style={{
//           backgroundImage: `url(${banner})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//           backgroundRepeat: "no-repeat",
//           height: "400px",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           color: "#fff",
//           width: "100%",
//           position: "relative",
//           overflow: "hidden"
//         }}
//       >
       
//         <div className="container" style={{marginTop:"300px"}}>
//           <div className="row">
//             <h2 style={{color:"#003A63"}}> Contact Us</h2>
//           </div>
//         </div>
//       </section>
     

//       {/* Breadcrumb Section */}
//       <section className="row breadcrumbRow">
//         <div className="container">
//           <div className="row inner m0">
//             <ul className="breadcrumb">
//               <li><Link to='/'>Home</Link>

//               </li>
//               <li>Contact Us</li>
//             </ul>
//           </div>
//         </div>
//       </section>
//       <section className="contact-section">
//   {/* Left Side: Contact Info */}
//   <div className="left">
//     <h3>Get in Touch</h3>
//     <div className="info">
//   <i className="fa fa-envelope" />
//   <span>contact@galoretx.com</span>
// </div>
// <div className="info">
//   <i className="fa fa-phone" style={{ color: "#48bb78" }} />
// &nbsp;<span>+91 8904443053</span>
// </div>
// <div className="info">
// <img 
//     src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" 
//     alt="WhatsApp" 
//     style={{ width: "20px", height: "20px", marginRight: "8px"}} 
//   />
//   <span>+91 9880258258</span>
// </div>
// {/* <div className="info">
//   <i className="fa fa-map-marker" style={{ color: "#f56565" }} /> 
//   <span>Galore Tx Pharmaceuticals, Bangalore Bioinnovation Centre, Electronics City Phase 1, Electronic City, Karnataka 56010</span>
// </div> */}

// <div className="info">
//   <i className="fa fa-map-marker" style={{ color: "#f56565" }} /> {/* red color */}
//   <span>
//     GaloreTx Pharmaceuticals Private Limited, 
//     1 BLR District, Survey No 43, Block A, 13 A & 13 B, 
//     Bhaktipura, Attibele Hobli, Bengaluru, Karnataka 562107
//   </span>
// </div>


//   </div>
//   {/* Right Side: Google Map */}
//   {/* <div className="right">
//     <h3>Our Location</h3>
//     <div className="map-container">
//       <iframe
//         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345086165!2d144.9537353153168!3d-37.81627997975144!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0xf5775dff46e97e2!2sArea%2051%2C%20Some%20near%20unknown%2C%20USA%20000000!5e0!3m2!1sen!2sin!4v1696866108577!5m2!1sen!2sin"
//         allowFullScreen=""
//         aria-hidden="false"
//         tabIndex={0}
//       ></iframe>
//     </div>
//   </div> */}
//   <div className="right">
//   <h3>Our Location</h3>
//   <div className="map-container">
//     <iframe
//       src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31187.17563397288!2d77.75476022366425!3d12.777357287166444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3e63b25cf8b3%3A0x5c0c6a0a0ee1bfbc!2sAttibele%2C%20Bengaluru%2C%20Karnataka%20562107%2C%20India!5e0!3m2!1sen!2sin!4v1705200000000!5m2!1sen!2sin"
//       style={{ border: 0, width: "100%", height: "300px" }}
//       allowFullScreen=""
//       loading="lazy"
//       referrerPolicy="no-referrer-when-downgrade"
//       aria-hidden="false"
//       tabIndex={0}
//     ></iframe>
//   </div>
// </div>

// </section>


// <Footer/>

//     </div>
//   )
// }

// export default Contact



import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../Css/Contact.css";
import { Link } from "react-router-dom";
import banner from "../banner/new.jpeg";
import building from "../img/GaloreTx-building.jpeg";

function Contact() {
  return (
    <div>
      <Header />

      {/* Page Intro Section */}
      <section
        className="row page_intro"
        style={{
          backgroundImage: `url(${banner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "400px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#fff",
          width: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="container" style={{ marginTop: "300px" }}>
          <div className="row">
            <h2 style={{ color: "#003A63" }}>Contact Us</h2>
          </div>
        </div>
      </section>

      {/* Breadcrumb Section */}
      <section className="row breadcrumbRow">
        <div className="container">
          <div className="row inner m0">
            <ul className="breadcrumb">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        {/* Left Side */}
        <div className="left">
          <h3>Get in Touch</h3>

          <div className="info">
            <i className="fa fa-envelope" />
            <span>contact@galoretx.com</span>
          </div>

          <div className="info">
            <i className="fa fa-phone" style={{ color: "#48bb78" }} />
            <span>+91 8904443053</span>
          </div>

          <div className="info">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
              alt="WhatsApp"
              style={{ width: "20px", height: "20px", marginRight: "8px" }}
            />
            <span>+91 9880258258</span>
          </div>

          <div className="info">
            <i className="fa fa-map-marker" style={{ color: "#f56565" }} />
            <span>
              GaloreTx Pharmaceuticals Private Limited, 1 BLR District, Survey No
              43, Block A, 13 A & 13 B, Bhaktipura, Attibele Hobli, Bengaluru,
              Karnataka 562107
            </span>
          </div>
        </div>

        {/* Right Side - Image */}
        <div className="right">
          {/* <h3>Our Infrastructure</h3> */}
          <div className="right-image-infrastructure">
            <img src={building} alt="Infrastructure" />
          </div>
        </div>
      </section>

      {/* Bottom Map */}
      {/* <div className="map-bottom">
        <h3>Our Location</h3>
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31187.17563397288!2d77.75476022366425!3d12.777357287166444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3e63b25cf8b3%3A0x5c0c6a0a0ee1bfbc!2sAttibele%2C%20Bengaluru%2C%20Karnataka%20562107%2C%20India!5e0!3m2!1sen!2sin!4v1705200000000!5m2!1sen!2sin"
            style={{ border: 0, width: "100%", height: "350px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div> */}

{/* <div className="map-bottom">
  <h3>Our Location</h3>
  <div className="map-container">
    <iframe
      src="https://www.google.com/maps?q=12.7566081,77.7664855&z=17&output=embed"
      style={{ border: 0, width: "100%", height: "350px" }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </div>
</div> */}
<div className="map-bottom">
  <h3>Our Location</h3>
  <div className="map-container">
    <iframe
  title="GaloreTx Pharmaceuticals Location Map"
  src="https://www.google.com/maps?q=Galore%20Tx%20Pharmaceuticals%2012.7566081,77.7664855&z=17&output=embed"
  style={{ border: 0, width: "100%", height: "350px" }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

  </div>
</div>


      <Footer />
    </div>
  );
}

export default Contact;
